import dayjs from 'dayjs';
import { IBannerLocale, ICreateBannerDTO } from '@/models/banners.model';
import { TBannerFormValues } from '../helpers';
import { DateFormats } from '@/constants/dates';
import { checkIfBinary } from '@/utils';

class CreateBannerDTO implements ICreateBannerDTO {
  start_date: string;
  expiration_date: string;
  active: '0' | '1';
  web_media?: Blob;
  mobile_media?: Blob;
  locale: IBannerLocale;

  constructor({ start_date, expiration_date, active, web_media, mobile_media, locale }: TBannerFormValues) {
    this.start_date = dayjs(start_date).format(DateFormats.DATE_YEAR_MONTH_DAY);
    this.expiration_date = dayjs(expiration_date).format(DateFormats.DATE_YEAR_MONTH_DAY);
    this.active = active;
    if (checkIfBinary(web_media)) {
      this.web_media = web_media;
    }
    if (checkIfBinary(mobile_media)) {
      this.mobile_media = mobile_media;
    }
    this.locale = locale;
  }
}

export default CreateBannerDTO;
